import React from 'react';

const TriangleUpIcon = () => {
	return (
		<svg
			data-testid='triangle-up'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M10 7.5L15 12.5L5 12.5L10 7.5Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default TriangleUpIcon;
